<template>
  <!-- 组件内容 -->
  <div class="textarea-con 222" :style="{ maxWidth: textAreaWidth }">
    <!--  输入框  -->
    <el-input
      type="textarea"
      v-model="searchValue"
      resize="none"
      :autosize="{ minRows: rowsNumber, maxRows: 10 }"
      placeholder="您可以在这里向我提问 ..."
      @keyup.enter.native="handleSendQuestion(searchValue)"
      :disabled="loading"
    />

    <!--  按钮  -->
    <div class="btn-con">
      <div class="flex items-center">
        <div class="flex items-center" style="margin-top: 5px">
          <span style="font-size: 13px; color: #777; margin: -1px 5px 0 0">是否联网</span>
          <el-switch
            v-model="isInternet"
            @change="handleChangeSwitch"
            active-color="#464BFE"
          />
        </div>
<!--        <el-tooltip
          effect="dark"
          content="是否联网"
          placement="top"
          transition=""
          popper-class="hover-popper"
        >
          <div>
            <img @click="handleChangeSwitch(false)" v-if="isInternet" src="@/assets/images/question/netword.png" height="22" width="22" />
            <img @click="handleChangeSwitch(true)" v-else src="@/assets/images/question/not_netword.png" height="22" width="22" />
          </div>

        </el-tooltip>-->
      </div>

      <el-tooltip
        effect="dark"
        content="请输入你的问题"
        placement="top"
        transition=""
        :disabled="!!searchValue"
        popper-class="hover-popper"
        v-show="!loading"
      >
<!--        <div-->
<!--          class="send-btn"-->
<!--          :style="{-->
<!--            cursor: /^\s*$/.test(searchValue) ? 'not-allowed' : 'pointer',-->
<!--            backgroundColor: /^\s*$/.test(searchValue)-->
<!--              ? 'rgb(214, 222, 232)'-->
<!--              : '#464BFE',-->
<!--          }"-->
<!--          @click="handleSendQuestion(searchValue)"-->
<!--        >-->
<!--          <sendIcon width="16" height="16" fill="#fff" />-->
<!--        </div>-->
        <div>
          <img
            @click="handleSendQuestion(searchValue)"
            v-if="!/^\s*$/.test(searchValue)"
            src="@/assets/images/question/pushText.png"
            height="30" width="30"
            alt="send"
          />
          <img
            @click="handleSendQuestion(searchValue)"
            v-else
            src="@/assets/images/question/not_text.png"
            height="30" width="30"
            alt="send"
          />
        </div>
      </el-tooltip>

      <el-tooltip
        effect="dark"
        content="终止回答"
        placement="bottom"
        transition=""
        popper-class="hover-popper"
        v-show="loading"
      >
        <div class="termination-btn" @click="handleAbortRequest">
          <p></p>
        </div>
      </el-tooltip>
    </div>
    <div class="ai-tips"
         v-if="$route.name === 'technicalQAHistory' || $route.name === 'technicalQAHistoryGuoJiao'">
      <span>注：该内容由AI大模型生成，请谨慎甄别</span>
    </div>


    <!-- 付费弹窗 -->
    <paymentDialog ref="scholarSearchPayment" payType="专家查询" />
    <paymentDialog ref="technicalQAPayment" payType="技术问答" />
  </div>
</template>

<script>
// import sendIcon from '@/assets/images/home/send-icon.svg';
import { createQuestionScholarApi, createQuestionGenerateApi } from '@/api/chat';
import paymentDialog from '@/components/PaymentDialog.vue';

export default {
  name: 'textareaComp',
  components: {
    // sendIcon,
    paymentDialog
  },
  // props: [
  //   'loading',    // 问题是否正在回答中
  // ],
  props: {
    loading: {
      type: Boolean,
    },
    textAreaWidth: {
      type: String,
      default: '1082px',
    },
    rowsNumber: {
      type: Number,
      default: 5,
    }
  },
  data() {
    return {
      searchValue: '',   // 检索值
      searchType: '',    // 检索类型
      isInternet: false, // 是否联网
      userId: '',        // 用户id
      chatId: '',        // 会话id
    };
  },
  created() {
    // 读取是否联网 持久化状态
    const isInternet = localStorage.getItem('at_isInternet');
    if (isInternet !== null) {
      this.isInternet = isInternet === 'true';
    }

    // 从localStorage中获取用户id
    this.userId = localStorage.getItem('at_userId') || 'test';

    // 根据路由名赋值 searchType
    const routeTypeMap = {
      scholarSearch: '1',
      scholarSearchHistory: '1',
      scholarSearchGuoJiao: '1',
      scholarSearchHistoryGuoJiao: '1',
      technicalQA: '2',
      technicalQAGuoJiao: '2',
      technicalQAHistory: '2',
      technicalQAHistoryGuoJiao: '2'
    };

    this.searchType = routeTypeMap[this.$route.name] || this.searchType;
    // if (this.$route.name.startsWith('scholarSearch')) {
    //   this.searchType = '1';
    // } else if (this.$route.name.startsWith('technicalQA')) {
    //   this.searchType = '2';
    // }
  },
  computed: {},
  methods: {
    /**
     * 是否联网切换
     * @param val
     */
    handleChangeSwitch(val) {
      // 存储是否联网持久化状态
      localStorage.setItem('at_isInternet', val);
      this.isInternet = val;
    },

    /**
     * 点击发送按钮
     * @param searchValue 输入框的内容
     */
    handleSendQuestion(searchValue) {

      if (!/^\s*$/.test(searchValue)) {
        // 如果在首页点击发送按钮，获取会话id并跳转到列表
        if (
          this.$route.name === 'scholarSearch' ||
          this.$route.name === 'technicalQA' ||
          this.$route.name === 'scholarSearchGuoJiao' ||
          this.$route.name === 'technicalQAGuoJiao'
        ) {
          let Api = this.searchType == 1 ? createQuestionScholarApi : createQuestionGenerateApi;
          // 新增对话
          Api({
            user_id: this.userId,
            title: searchValue?.replace(/\n/g, ''),
          }).then((res) => {
            // 发送完问题后清空输入框
            this.searchValue = '';
            this.chatId = res.question_id;

            this.$router.push({
              name: this.toRouteName(this.$route.name),
              params: {
                id: this.chatId,
                question: searchValue?.replace(/\n/g, ''),
              },
            });
          }).catch(error => {
            // 付费弹窗
            if (error.response?.status === 429) {
              this.confirmPay(this.searchType);
              return false;
            }
            // 其他错误处理
            else {
              this.$message.error('服务器出错啦，请稍后重试');
            }
          })
        }

        // 如果在列表页点击发送，不需要跳转直接传递数据
        else {
          this.$emit('sendQuestion', {
            searchValue: searchValue?.replace(/\n/g, ''),
            isInternet: this.isInternet,
            searchType: this.searchType,
          });
        }
      }
    },

    // 是否购买 对话框
    confirmPay(searchType) {
      this.$confirm('您的访问次数已达上限，如需继续使用可购买次数，是否立即购买？', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '立即购买',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        searchType == 1 ? this.$refs.scholarSearchPayment.open() : this.$refs.technicalQAPayment.open();
      }).catch(() => {
      });
    },

    // 终止请求
    handleAbortRequest() {
      this.$emit('abortRequest', this.$route.name === 'scholarSearchHistory' ? '1' : '2');
    },

    // 通过当前路由名判断跳转的详情
    toRouteName(routeName) {
      if (routeName === 'scholarSearch') {
        return 'scholarSearchHistory';
      } else if (routeName === 'technicalQA') {
        return 'technicalQAHistory';
      } else if (routeName === 'scholarSearchGuoJiao') {
        return 'scholarSearchHistoryGuoJiao';
      } else if (routeName === 'technicalQAGuoJiao') {
        return 'technicalQAHistoryGuoJiao';
      }
    }
  },
  watch: {
    // 监听路由id，发生改变后调接口
    ['$route.params.id']: {
      handler() {
        this.searchValue = '';
      },
      immediate: false,
    },
  },
};
</script>

<style scoped lang="less">
.textarea-con {
  position: relative;
  min-height: 120px;
  border-radius: 15px;
  background-color: #FFFFFF;
  box-sizing: border-box;
  padding: 20px 10px 15px;
  //width: 1082px;
  box-shadow: 0px 2px 7px 1px rgba(16, 53, 102, 0.1);
  border: 1px solid #DEE2E9;

  .el-textarea {
    /deep/.el-textarea__inner {
      padding: 0 10px 10px !important;
      background: transparent;
      font-size: 16px !important;
      border: 0;
      line-height: 26px;
    }
  }

  .btn-con {
    display: flex;
    margin: 10px 20px 0 10px;
    justify-content: space-between;

    .btn-item {
      width: 110px;
      height: 30px;
      color: #4c4c4c;
      border-radius: 15px;
      border: 2px solid #e5e5e5;
      font-size: 13px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ffffff;
      user-select: none;
      margin-right: 10px;

      span {
        margin-left: 5px;
      }
    }

    > div:nth-of-type(3) {
      img {
        width: 14px;
      }
    }

    .btn-item.active {
      color: #464BFE;
      border-color: #464BFE;
    }

    .send-btn {
      background-color: #464BFE;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      //margin-right: 15px;
      cursor: pointer;

      svg {
        margin-left: -2px;
      }
    }

    .termination-btn {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      //margin-right: 15px;
      cursor: pointer;
      background-color: #464BFE;

      p {
        width: 11px;
        height: 11px;
        background-color: #fff;
      }
    }
  }
}

.ai-tips {
  position: absolute;
  bottom: -20px;
  left: 0px;
  text-align: center;
  width: 100%;
  z-index: 9999;
  span {
    color: #999999;
    font-size: 11px;
    letter-spacing: 0.5px;
  }
}
</style>
